
export default class Faqs {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $tableRows: $('.faq-table tr'),
            $faqTxt: $('.faq-body'),
            $filter: $('.faq-filter .filter-btn'),
            $searchTxt: $('#search-text'),
            $searchBtn: $('.search-trigger')
        };

        if (this.dom.$tableRows.length) {
            this.init();
        }
    }

    init() {
        this.events();
    }

    events() {

        var thisdom = this.dom;

        //Surpress Enter submitting form
        $(document).on('keypress', function (e) {
            if (e.which == 13) {
                if (thisdom.$searchTxt.val().length > 0) {
                    thisdom.$searchBtn.trigger('click');
                } else {
                    thisdom.$tableRows.show();
                }
                return false;
            }
        });

        //Setup search function
        thisdom.$searchBtn.on('click', function () {
            thisdom.$tableRows.each(function () {
                var isfound = ($(this).find(thisdom.$faqTxt).text().toLowerCase().indexOf(thisdom.$searchTxt.val().toLowerCase()) > -1);
                $(this).toggle(isfound);
            });
            thisdom.$filter.removeClass('selectedOffer');
        })

        //Reset search if empty
        thisdom.$searchTxt.on('blur', function () {
            if (thisdom.$searchTxt.val() == "") {
                thisdom.$tableRows.show();
            }
        })

        //Setup filter function
        thisdom.$filter.off('click').on('click', function () {
            if ($(this).hasClass('selectedOffer')) {
                thisdom.$tableRows.show();
                $(this).removeClass('selectedOffer');
            } else {
                var filterKey = $(this).data('filter');
                $('.selectedOffer').removeClass('selectedOffer');
                $(this).addClass('selectedOffer');
                thisdom.$tableRows.each(function () {
                    $(this).toggle(filterKey == $(this).data('filter'));
                });
            }
            thisdom.$searchTxt.val('');
        });

        //Close other open FAQs
        $('.accordion-trigger').on('click', function () {
            var $openFAQ = $('.accordion-trigger.accordion-open').not(this);
            if ($openFAQ.length > 0) {
                $openFAQ.find('.faq-answer').slideUp('slow');
                $openFAQ.removeClass('accordion-open')
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => new Faqs());
